export default "__VITE_ASSET__B6Y4FnS0__"